import React from "react";

interface ComingSoonProps {
  module: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ module }) => {
  return (
    <div className="coming-soon-container">
      <div className="coming-soon-card">
        <div className="coming-soon-icon">�</div>
        <h2 className="coming-soon-title">{module}</h2>
        <p className="coming-soon-message">This module is currently under development.</p>
        <p className="coming-soon-sub" style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          gap: '0.75rem',
          fontSize: '1.125rem',
          fontWeight: 600,
          marginTop: '1.5rem'
        }}>
          <span style={{ 
            width: '12px', 
            height: '12px', 
            borderRadius: '50%', 
            background: 'var(--brand-green)',
            animation: 'blink 1s infinite',
            boxShadow: '0 0 12px var(--brand-green)'
          }} />
          Pulling data...
        </p>
      </div>
      <style>{`
        @keyframes blink {
          0%, 50% { opacity: 1; }
          51%, 100% { opacity: 0.2; }
        }
      `}</style>
    </div>
  );
};

export default ComingSoon;